import apiClient from './api.service';

export interface EmailConsentState {
  marketingConsent: boolean;
  emailConsentAt: string | null;
}

class EmailConsentService {
  async fetchConsent(): Promise<EmailConsentState | null> {
    try {
      const response = await apiClient.get<{ data: EmailConsentState }>('/api/profile/email-consent');
      return response.data.data ?? null;
    } catch {
      return null;
    }
  }

  async updateConsent(marketingConsent: boolean): Promise<void> {
    await apiClient.patch('/api/profile/email-consent', { marketingConsent });
  }
}

export const emailConsentService = new EmailConsentService();
